import * as z from 'zod/v4';

export const customerIdSchema = z.number().brand<'CustomerId'>();
